__turbopack_context__.v({
  "card": "CardMarquee-module__TZxl5W__card",
  "cardText": "CardMarquee-module__TZxl5W__cardText",
  "cardTitle": "CardMarquee-module__TZxl5W__cardTitle",
  "head": "CardMarquee-module__TZxl5W__head",
  "iconBox": "CardMarquee-module__TZxl5W__iconBox",
  "label": "CardMarquee-module__TZxl5W__label",
  "media": "CardMarquee-module__TZxl5W__media",
  "nav": "CardMarquee-module__TZxl5W__nav",
  "navButton": "CardMarquee-module__TZxl5W__navButton",
  "section": "CardMarquee-module__TZxl5W__section",
  "set": "CardMarquee-module__TZxl5W__set",
  "track": "CardMarquee-module__TZxl5W__track",
});
